<div class="px-4 py-4 hover:bg-[#FEF4F4] transition-all ease-in-out delay-100 w-full">
  <div class="flex justify-between">
    <div class="flex items-center w-full">
      <nz-avatar
        [nzSize]="56"
        class="me-3"
        nzIcon="user"
        nzSrc="//zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
      ></nz-avatar>
      <p class="text-gray-600 w-3/4">
        <span class="font-bold text-gray-700">بريق أحمد</span>
        قام بحجز رحلة جديدة يمكنك رؤيتها في صفحة الحجوزات.
      </p>
    </div>
    <div class="shrink-0 flex items-end flex-col">
      <p class="text-gray-500">منذ 5 دقيقة</p>
      <button nz-button nzType="text">
        <span nz-icon nzType="delete" class="text-primary" nzTheme="outline"></span>
      </button>
    </div>
  </div>
</div>
